import { render, staticRenderFns } from "./recommended.vue?vue&type=template&id=f011cf84"
import script from "./recommended.vue?vue&type=script&lang=js"
export * from "./recommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports